<div class="page-wrapper section-hr-direct">
    <app-left-menu [showMenu]="false"></app-left-menu>
    <div id="main-container">
        <app-header [showHistoryButton]="true" [title]="title"></app-header>
        <div class="content-header"> </div>
        <div class="page-content settings">
            <div class="no-absolute m-t30">

                <form [formGroup]="availabilityForm">
                    <label>{{'Availability.Label.FromDate' | translate}}<span class="required">*</span></label>
                
                    <input type="text" class="date fromdate" formControlName="FromDate">
                    <label>{{'Availability.Label.ToDate' | translate}}<span class="required">*</span></label>
                   
                    <input type="text" class="date todate" formControlName="ToDate">
     
                   

                    <label>{{'Availability.Label.Notes' | translate}}<span class="required">*</span></label>
 
                    <textarea placeholder="{{'Common.Placeholder.Notes' | translate}}" [showinitial]=true appCharCount [limit]=500
                    maxlength="500"  formControlName="Notes" style="padding:0px 10px 0px"></textarea>
                    <span id="char-count" class="char-count"></span>

                    <div>
                        <span class="error-message" *ngIf="error"> {{error}}</span>
                        
                        <div >
                            <input type="submit" id="login" (click)="AddAvailability(availabilityForm.value)"
                                [disabled]="!availabilityForm.valid" class="btn btn-main"
                                value="{{'Common.Save' | translate}}" />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>